import React from "react";

const Scroll = () => {
  return (
    <div
      style={{
        width: "75vw",
        maxWidth: "1290px",
        margin: "10vh auto",
        textAlign: "left",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Heading + Tagline */}
      <div style={{ marginBottom: "2rem" }}>
        <h1
          style={{
            fontSize: 36,
            fontWeight: "bold",
			fontFamily: 'Arial',
            color: "#0D1C17",
            marginBottom: "0.5rem",
          }}
        >
          Our Services
        </h1>
        <p
          style={{
            fontSize: "16",
			fontFamily: 'Arial',
            color: "#0D1C17",
            // fontStyle: "italic",
            lineHeight: "1.6",
          }}
        >
          Innovating Tomorrow Where Climate Meets Technology
        </p>
      </div>

      {/* Two Cards – Side by Side with 12px gap */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 16, // ← 12px gap between cards
          flexWrap: "wrap",
		  width: 'auto',
		  height: 'auto'
        }}
      >
        {/* Card 1 */}
        <div
          style={{
            background: "#F7FCFA",
            borderRadius: 8,
            padding: "1rem",
            border: "2px solid #CCEBE3", // ← Red border
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.05)",
            flex: "1",
            width : 'auto',
			height : 'auto'
          }}
        >
          <div style={{ marginBottom: "1rem" }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1374_1763)">
                <path fillRule="evenodd" clipRule="evenodd" d="M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.7443 6.61758 17.3824 2.25568 12 2.25ZM20.25 12C20.2508 13.0584 20.0471 14.107 19.65 15.0881L15.4594 12.5109C15.2812 12.401 15.0819 12.3298 14.8744 12.3019L12.735 12.0131C12.1323 11.9345 11.5412 12.2249 11.235 12.75H10.4175L10.0612 12.0131C9.86166 11.5973 9.48093 11.2972 9.03 11.2003L8.28 11.0381L9.01313 9.75H10.5797C10.8332 9.7495 11.0824 9.68501 11.3044 9.5625L12.4528 8.92875C12.5537 8.87251 12.648 8.80522 12.7341 8.72812L15.2569 6.44625C15.7779 5.97931 15.9049 5.21324 15.5625 4.60313L15.5288 4.54219C18.4101 5.90842 20.2477 8.81115 20.25 12ZM13.4353 3.87562L14.25 5.33437L11.7272 7.61625L10.5797 8.25H9.01313C8.47644 8.24921 7.98022 8.53521 7.71187 9L6.89344 10.4278L5.94187 7.89281L6.9675 5.4675C8.80317 4.04914 11.1518 3.47049 13.4362 3.87375L13.4353 3.87562ZM3.75 12C3.74875 10.7738 4.02233 9.56284 4.55062 8.45625L5.61375 11.2941C5.79378 11.7715 6.20418 12.1247 6.70312 12.2316L8.71219 12.6637L9.06938 13.4062C9.32224 13.9214 9.84551 14.2484 10.4194 14.25H10.5581L9.88031 15.7716C9.63621 16.3192 9.74165 16.9596 10.1484 17.4L10.1616 17.4131L12 19.3069L11.8181 20.2444C7.33749 20.1401 3.75743 16.4818 3.75 12ZM13.3669 20.1356L13.4728 19.5909C13.5611 19.1217 13.422 18.6384 13.0978 18.2878C13.0932 18.2837 13.0888 18.2793 13.0847 18.2747L11.25 16.3819L12.5344 13.5L14.6737 13.7887L18.96 16.425C17.7042 18.3971 15.6721 19.7453 13.3669 20.1356Z" fill="#0D1C17"/>
              </g>
              <defs>
                <clipPath id="clip0_1374_1763">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>

          <h3
            style={{
             width: 222,
			  height: 20,
              fontWeight: "600",
              color: "#0D1C17",
              margin: "0.8rem 0",
            }}
          >
            Climate & Water Intelligence
          </h3>

          <p
            style={{
            width: 'auto',
		   height: 'auto',
              color: "#45A187",
            //   lineHeight: "2.6",
            //   margin: 0,
            }}
          >
            Analytics and insights for sustainable resource management.
          </p>
        </div>

        {/* Card 2 */}
        <div
          style={{
             background: "#F7FCFA",
            borderRadius: 8,
            padding: "1rem",
            border: "2px solid #CCEBE3", // ← Red border
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.05)",
            flex: "1",
            width : 'auto',
			height : 'auto'
          }}
        >
          <div style={{ marginBottom: "1rem" }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.6668 25.959V22.9472L21.3898 23.4063C21.6285 23.4465 21.8729 23.4368 22.1076 23.3778C22.3423 23.3188 22.5622 23.2117 22.7534 23.0633C22.9446 22.915 23.103 22.7286 23.2185 22.5159C23.334 22.3033 23.4041 22.069 23.4245 21.8278L23.7593 17.8542C24.8385 17.6121 25.6143 17.2218 26.1177 16.8963C26.5692 16.6047 26.6217 16.0155 26.3207 15.5698L23.9022 11.9899C23.6152 6.60865 19.1609 2.33398 13.7085 2.33398V25.959" stroke="#0D1C17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1.75 14C1.75 14.4641 1.93437 14.9092 2.26256 15.2374C2.59075 15.5656 3.03587 15.75 3.5 15.75C3.96413 15.75 4.40925 15.5656 4.73744 15.2374C5.06563 14.9092 5.25 14.4641 5.25 14C5.25 13.5359 5.06563 13.0908 4.73744 12.7626C4.40925 12.4344 3.96413 12.25 3.5 12.25C3.03587 12.25 2.59075 12.4344 2.26256 12.7626C1.93437 13.0908 1.75 13.5359 1.75 14ZM4.66667 5.25C4.66667 5.47981 4.71193 5.70738 4.79988 5.9197C4.88782 6.13202 5.01673 6.32493 5.17923 6.48744C5.34173 6.64994 5.53465 6.77884 5.74697 6.86679C5.95929 6.95473 6.18685 7 6.41667 7C6.64648 7 6.87404 6.95473 7.08636 6.86679C7.29868 6.77884 7.4916 6.64994 7.6541 6.48744C7.81661 6.32493 7.94551 6.13202 8.03346 5.9197C8.1214 5.70738 8.16667 5.47981 8.16667 5.25C8.16667 5.02019 8.1214 4.79262 8.03346 4.5803C7.94551 4.36798 7.81661 4.17507 7.6541 4.01256C7.4916 3.85006 7.29868 3.72116 7.08636 3.63321C6.87404 3.54526 6.64648 3.5 6.41667 3.5C6.18685 3.5 5.95929 3.54526 5.74697 3.63321C5.53465 3.72116 5.34173 3.85006 5.17923 4.01256C5.01673 4.17507 4.88782 4.36798 4.79988 4.5803C4.71193 4.79262 4.66667 5.02019 4.66667 5.25ZM4.08333 23.3333C4.08333 23.7975 4.26771 24.2426 4.5959 24.5708C4.92409 24.899 5.3692 25.0833 5.83333 25.0833C6.29746 25.0833 6.74258 24.899 7.07077 24.5708C7.39896 24.2426 7.58333 23.7975 7.58333 23.3333C7.58333 22.8692 7.39896 22.4241 7.07077 22.0959C6.74258 21.7677 6.29746 21.5833 5.83333 21.5833C5.3692 21.5833 4.92409 21.7677 4.5959 22.0959C4.26771 22.4241 4.08333 22.8692 4.08333 23.3333Z" stroke="#0D1C17" strokeWidth="1.5"/>
              <path d="M5.25 14.0007H13.7083M13.7083 9.33398H10.5L7.875 6.70898M13.7083 19.2507H9.91667L7.29167 21.8757" stroke="#0D1C17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <h3
            style={{
              width: 222,
			  height: 20,
              fontWeight: "600",
              color: "#0D1C17",
              margin: "0.8rem 0",
            }}
          >
            IT & Data Science Solutions
          </h3>

          <p
            style={{
               width: 'auto',
		   height: 'auto',
              color: "#45A187",
            //   lineHeight: "2.6",
            //   margin: 0,
            }}
          >
            Data-driven software development for environmental innovation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Scroll;